module.exports = __webpack_public_path__ + "img/balance_connectee_particulier.d57bff5b.png";